export const VIEW_TYPES = {
  DOCUMENT: 'DOCUMENT',
  RECEIVER: 'RECEIVER',
};
